import { getEnvParam } from "@/env";

interface DistributionStat {
    min: number;
    max: number;
    count: number;
}

interface IndicatorStat {
    distribution: DistributionStat[];
    min: number;
    max: number;
    count: number;
}

export async function getIndicatorStat(
    indicatorId: number,
): Promise<IndicatorStat> {
    const result = await fetch(
        `${process.env.BUN_PUBLIC_TILE_SERVER}/api/indicators/${indicatorId}/stats?${getEnvParam()}`,
        {
            headers: {
                "X-API-KEY": process.env.BUN_PUBLIC_TILE_SERVER_API_KEY
            }
        }
    );

    // TODO: Error handling;

    return result.json();
}
